export const PILL_STATUS = Object.freeze({
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    WARNING: 'WARNING',
    INFO: 'INFO',
    HIGHLIGHT: 'HIGHLIGHT',
});
export const PILL_STATUS_PROPS = {
    SUCCESS: {
        borderColor: 'grass',
        iconColor: 'grass',
    },
    ERROR: {
        borderColor: 'fire',
        iconColor: 'fire',
    },
    WARNING: {
        borderColor: 'mandarine',
        iconColor: 'mandarine',
    },
    INFO: {
        borderColor: 'horizon',
        iconColor: 'asphalt',
    },
    HIGHLIGHT: {
        borderColor: 'primary',
        iconColor: 'primary',
    },
};
//# sourceMappingURL=constants.js.map